const Pipeline = (function () {
    let handleAction = 'handle';
    let data = null;
    let actions = null;

    function Pipeline() {}

    Pipeline.prototype.send = function (givenData = null) {
        data = givenData;

        return this;
    }

    Pipeline.prototype.through = function (throughActions = null) {
        actions = throughActions;

        return this;
    }

    Pipeline.prototype.handleVia = function (handleActionName) {
        handleAction = handleActionName;

        return this;
    }

    Pipeline.prototype.thenReturn = function () {
        handle();

        return data;
    }

    function handle () {
        if (!actions) {
            return this;
        }

        if(!actions.length) {
            return this;
        }

        for (let i = 0; i < actions.length; i++) {
            const currentAction = actions[i];

            const action = currentAction[handleAction];

            if (!action(data)) {
                throw new Error('Something went wrong.');
            }
        }
    }

    return Pipeline;
})();

export default Pipeline;